import React from 'react';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  title: string;
  subtitle: string;
}

const PostsEmptyState = ({title, subtitle}: Props) => {
  return (
    <div className="EmptyStateContainer">
      <Icon name="posts-menu.svg" className="SpanIcon" />
      <p className="Title">{title}</p>
      <p className="Title">{subtitle}</p>
    </div>
  );
};

export default PostsEmptyState;
